import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Propaganda Carousel',
		description:
			'Round and round the talking points go, where they stop, nobody knows!'
	},
	{
		name: 'Promise Coaster',
		description:
			'The ups are high, the downs are low, and nothing ever actually changes!'
	},
	{
		name: 'Quantum Voting Booth Ride',
		description:
			'Experience the thrill of voting for all candidates simultaneously!'
	},
	{
		name: 'Temporal Campaign Trail',
		description:
			'A historical journey where every promise has already been broken.'
	},
	{
		name: 'Multiverse Debate Stage',
		description: 'Watch yourself win every argument in parallel universes.'
	},
	{
		name: 'Infinite Spin Room',
		description: 'The room keeps spinning until reality matches your narrative.'
	},
	{
		name: 'Void of Accountability',
		description: 'A black hole that makes campaign promises disappear forever.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Campaign Theme Parks'],
	departments[DepartmentIds['Campaign Theme Parks']].basePrice * 3,
	UpgradeIds.CtpExponent1
)

export default array
